import { render, staticRenderFns } from "./View.vue?vue&type=template&id=4e261eaf"
import script from "./View.vue?vue&type=script&lang=js"
export * from "./View.vue?vue&type=script&lang=js"
import style0 from "./View.vue?vue&type=style&index=0&id=4e261eaf&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4e261eaf')) {
      api.createRecord('4e261eaf', component.options)
    } else {
      api.reload('4e261eaf', component.options)
    }
    module.hot.accept("./View.vue?vue&type=template&id=4e261eaf", function () {
      api.rerender('4e261eaf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/vertical/View.vue"
export default component.exports